import { useParams } from "react-router-dom"; // Step 1: Import useParams
import React, { useState, useEffect } from "react";
import {
  TextField,
  Button,
  Container,
  Box,
  Typography,
  MenuItem,
} from "@mui/material";
import { Get_One_From_MongoDB } from "../../../api/Get_One_From_MongoDB";
import { Post_School_Event_To_MongoDB_And_HubSpot } from "./api/Post_School_Event_To_MongoDB_And_HubSpot";
import { Get_Hubspot_Owners } from "../api/Get_Hubspot_Owners";
import { Link } from "react-router-dom";
import { StaffuseAuth } from "../../../security/StaffuseAuth";

const LogSchoolEvent = () => {
  //The below gets the ID from the url
  const { id } = useParams();
  const { Contactid } = useParams();
  const { logout } = StaffuseAuth();

  //Check it exists
  const [CheckSchool, setCheckSchool] = useState({
    HubspotCompanyID: "Searching",
  });
  useEffect(() => {
    Get_One_From_MongoDB("Schools", "All_Schools", id, setCheckSchool, logout);
  }, []);

  //Hubspot Owners
  const [HubspotOwners, setHubspotOwners] = useState({ results: [] });
  useEffect(() => {
    Get_Hubspot_Owners(setHubspotOwners, logout);
  }, []);

  //find the object in the array of HubspotOwners.results that has  localStorage.getItem("Username"); as the value of result.email
  console.log("HubspotOwners");
  console.log(HubspotOwners);

  const HubspotOwner = HubspotOwners.results.find(
    (result) => result.email === localStorage.getItem("Username")
  );

  useEffect(() => {
    setEvent({
      ...Event,
      hubspot_owner_id: HubspotOwner ? HubspotOwner.id : "",
    });
  }, [HubspotOwners]);

  //The below is the state for the form
  const [Event, setEvent] = useState({
    //No _id needed
    Date: new Date().toISOString(),
    School_id: id,
    Staff_id: localStorage.getItem("_id"),
    hubspot_owner_id: "",
    hs_timestamp: "",
    hs_meeting_title: "",
    hs_activity_type: "",
    hs_meeting_outcome: "COMPLETED",
    Specifics: { year_group: [] },
    ExtraTask: { Need: "No", Body: "", Subject: "", Time: "" },
    ExtraTask2: { Need: "No", Body: "", Subject: "", Time: "" },
    ExtraTask3: { Need: "No", Body: "", Subject: "", Time: "" },
  });

  //This is the handleChange function
  const handleChange = (prop) => (event) => {
    setEvent({ ...Event, [prop]: event.target.value });
  };

  // Functions for handling changes in type
  const handleTypeChange = (prop) => (e) => {
    setEvent({
      ...Event,
      [prop]: e.target.value,
      Specifics: { year_group: [] },
    });
  };

  // Functions for handling changes in specifics
  const handleSpecificsChange = (e) => {
    setEvent({
      ...Event,
      Specifics: { ...Event.Specifics, [e.target.name]: e.target.value },
    });
  };

  // Functions for handling changes in Extra Task
  const handleExtraTaskChange = (e) => {
    setEvent({
      ...Event,
      ExtraTask: { ...Event.ExtraTask, [e.target.name]: e.target.value },
    });
  };
  const handleExtraTask2Change = (e) => {
    setEvent({
      ...Event,
      ExtraTask2: { ...Event.ExtraTask2, [e.target.name]: e.target.value },
    });
  };

  const handleExtraTask3Change = (e) => {
    setEvent({
      ...Event,
      ExtraTask3: { ...Event.ExtraTask3, [e.target.name]: e.target.value },
    });
  };

  //The below is the state for the Submit button
  const [isSubmitting, setIsSubmitting] = useState(false);

  //This is the handleSubmit function

  const handleSubmit = (event) => {
    event.preventDefault();
    //Post_To_MongoDB(Event, "Schools", "Events_2025", setIsSubmitting);
    Post_School_Event_To_MongoDB_And_HubSpot(
      Event,
      CheckSchool.HubspotCompanyID,
      setIsSubmitting,
      Contactid,
      logout
    );
  };

  //This is the state for the form validity
  const [isFormValid, setIsFormValid] = useState(false);

  //The below is the useEffect to check if the form is valid
  useEffect(() => {
    // Check if all required fields are filled out
    const checkFormValidity = () => {
      return (
        Event.School_id !== "" &&
        Event.Staff_id !== "" &&
        Event.Date !== "" &&
        Event.hs_activity_type !== "" &&
        Event.hs_timestamp !== "" &&
        Event.hs_meeting_title !== "" &&
        Event.hubspot_owner_id !== ""
      );
    };

    setIsFormValid(checkFormValidity());
  }, [Event]); // This effect runs whenever the school state changes

  return (
    <div style={{ backgroundColor: "#e5e5e5", minHeight: "93vh" }}>
      {" "}
      <div
        name="space"
        style={{ width: "100%", height: "40px", flex: "0 1 auto" }}
      ></div>
      <Container maxWidth="h">
        <Typography variant="h6" gutterBottom>
          Log School Event to:{" "}
          {CheckSchool.School_Name
            ? CheckSchool.School_Name
            : "ERROR - SCHOOL NOT FOUND PLEASE CLOSE TAB AND TRY AGAIN"}{" "}
          for Contact with Hubspot id {Contactid}
        </Typography>
        {CheckSchool.HubspotCompanyID === "Searching" ? (
          <Typography variant="h6" gutterBottom>
            Loading...
          </Typography>
        ) : CheckSchool.HubspotCompanyID ? (
          <Typography variant="h6" gutterBottom>
            <Box
              component="form"
              sx={{
                "& .MuiTextField-root": { m: 1, width: "25ch" },
              }}
              noValidate
              autoComplete="off"
              onSubmit={handleSubmit}
            >
              <section>
                <TextField
                  required
                  id="School_id"
                  label="School_id"
                  value={Event.School_id}
                  disabled={true}
                  InputLabelProps={{ shrink: true }}
                  style={{ width: "400px" }}
                />
                <TextField
                  required
                  id="Staff_id"
                  label="Staff_id"
                  value={Event.Staff_id}
                  disabled={true}
                  InputLabelProps={{ shrink: true }}
                  style={{ width: "400px" }}
                />
                <TextField
                  required
                  id="HubspotCompanyID"
                  label="HubspotCompanyID"
                  value={CheckSchool.HubspotCompanyID}
                  disabled={true}
                  InputLabelProps={{ shrink: true }}
                  style={{ width: "400px" }}
                />
                <TextField
                  required
                  id="School_Name"
                  label="School_Name"
                  value={CheckSchool.School_Name}
                  disabled={true}
                  InputLabelProps={{ shrink: true }}
                  style={{ width: "400px" }}
                />
                <TextField
                  required
                  select
                  id="hubspot_owner_id"
                  label="hubspot_owner_id"
                  name="hubspot_owner_id"
                  value={Event.hubspot_owner_id}
                  onChange={handleChange("hubspot_owner_id")}
                  helperText="Please select your option"
                  InputLabelProps={{ shrink: true }}
                  style={{ width: "400px" }}
                >
                  <MenuItem value=""></MenuItem>
                  {HubspotOwners.results.map((result) => (
                    <MenuItem value={result.id}>{result.email}</MenuItem>
                  ))}

                  {/* <MenuItem value="00000000">00000000</MenuItem> */}
                </TextField>
                <TextField
                  required
                  id="hs_timestamp"
                  label="When was the meeting?"
                  value={Event.hs_timestamp}
                  name="hs_timestamp"
                  onChange={handleChange("hs_timestamp")}
                  type="datetime-local"
                  InputLabelProps={{ shrink: true }}
                  style={{ width: "400px" }}
                />
                <TextField
                  required
                  id="hs_meeting_start_time"
                  label="hs_meeting_start_time"
                  value={Event.hs_timestamp}
                  name="hs_timestamp"
                  onChange={handleChange("hs_meeting_start_time")}
                  type="datetime-local"
                  InputLabelProps={{ shrink: true }}
                  style={{ width: "400px" }}
                  disabled={true}
                />
                <TextField
                  required
                  id="hs_meeting_end_time"
                  label="When did the meeting end"
                  value={Event.hs_meeting_end_time}
                  name="hs_meeting_end_time"
                  onChange={handleChange("hs_meeting_end_time")}
                  type="datetime-local"
                  InputLabelProps={{ shrink: true }}
                  style={{ width: "400px" }}
                />
                <TextField
                  required
                  id="hs_meeting_title"
                  label="Meeting Title"
                  value={Event.hs_meeting_title}
                  name="hs_meeting_title"
                  onChange={handleChange("hs_meeting_title")}
                  InputLabelProps={{ shrink: true }}
                  style={{ width: "400px" }}
                />

                <TextField
                  required
                  select
                  id="hs_activity_type"
                  label="hs_activity_type"
                  value={Event.hs_activity_type}
                  onChange={handleTypeChange("hs_activity_type")}
                  helperText="Please select your option"
                  InputLabelProps={{ shrink: true }}
                  style={{ width: "400px" }}
                >
                  <MenuItem value="Meeting - Online">Meeting - Online</MenuItem>
                  <MenuItem value="Meeting - In Person">
                    Meeting - In Person
                  </MenuItem>
                  <MenuItem value="Presentation - Online">
                    Presentation - Online
                  </MenuItem>
                  <MenuItem value="Presentation - In Person">
                    Presentation - In Person
                  </MenuItem>
                  <MenuItem value="Careers Fair">Careers Fair</MenuItem>
                </TextField>
                <TextField
                  required
                  select
                  id="next_aim"
                  label="Next Aim"
                  name="next_aim"
                  value={Event.Specifics.next_aim}
                  onChange={handleSpecificsChange}
                  helperText="Please select your option"
                  InputLabelProps={{ shrink: true }}
                  style={{ width: "400px" }}
                >
                  <MenuItem value="Student Presentation">
                    Student Presentation
                  </MenuItem>
                  <MenuItem value="Parent Presentation">
                    Parent Presentation
                  </MenuItem>
                  <MenuItem value="Teacher Meeting">Teacher Meeting</MenuItem>
                  <MenuItem value="TCS Meeting">TCS Meeting</MenuItem>
                  <MenuItem value="Careers Fair Attendance">
                    Careers Fair Attendance
                  </MenuItem>
                </TextField>
              </section>
              <Typography variant="h6" gutterBottom>
                Event Type Specific Details:
              </Typography>
              {Event.hs_activity_type === "Meeting - Online" ||
              Event.hs_activity_type === "Meeting - In Person" ? (
                <>
                  <TextField
                    required
                    select
                    id="warmth"
                    label="Warmth"
                    name="warmth"
                    value={Event.Specifics.Warmth}
                    onChange={handleSpecificsChange}
                    helperText="Please select your option"
                    InputLabelProps={{ shrink: true }}
                    style={{ width: "400px" }}
                  >
                    <MenuItem value="Hot">Hot</MenuItem>
                    <MenuItem value="Warm">Warm</MenuItem>
                    <MenuItem value="Cold">Cold</MenuItem>
                  </TextField>
                  <TextField
                    required
                    id="actions_agreed"
                    label="Actions Agreed"
                    value={Event.Specifics.actions_agreed}
                    name="actions_agreed"
                    onChange={handleSpecificsChange}
                    InputLabelProps={{ shrink: true }}
                    style={{ width: "80%" }}
                    multiline
                    rows={5}
                    fullWidth
                  />
                  <TextField
                    required
                    id="discussion_points"
                    label="Discussion Points"
                    value={Event.Specifics.discussion_points}
                    name="discussion_points"
                    onChange={handleSpecificsChange}
                    style={{ width: "80%" }}
                    multiline
                    rows={5}
                    fullWidth
                    placeholder="Enter 3 discussion points here... 
                    1)
                    2)
                    3)
                    " // Placeholder text
                    InputLabelProps={{ shrink: true }}
                    InputProps={{
                      style: {
                        "&::placeholder": {
                          color: "rgba(0, 0, 0, 0.5)", // Semi-transparent grey color
                        },
                      },
                    }}
                  />
                </>
              ) : (
                <></>
              )}
              {Event.hs_activity_type === "Presentation - Online" ||
              Event.hs_activity_type === "Presentation - In Person" ? (
                <>
                  <TextField
                    required
                    select
                    id="topic"
                    label="Topic"
                    name="topic"
                    value={Event.Specifics.topic}
                    onChange={handleSpecificsChange}
                    helperText="Please select your option"
                    InputLabelProps={{ shrink: true }}
                    style={{ width: "400px" }}
                  >
                    <MenuItem value="SXP Sell">SXP Sell</MenuItem>
                    <MenuItem value="Essential Employability Skills">
                      Essential Employability Skills
                    </MenuItem>
                    <MenuItem value="Navigating Your Next Steps">
                      Navigating Your Next Steps
                    </MenuItem>
                    <MenuItem value="Making the Most of Work Experience">
                      Making the Most of Work Experience
                    </MenuItem>
                    <MenuItem value="Other">Other</MenuItem>
                  </TextField>
                  <TextField
                    required
                    select
                    id="number_of_presentations"
                    label="number_of_presentations"
                    name="number_of_presentations"
                    value={Event.Specifics.number_of_presentations}
                    onChange={handleSpecificsChange}
                    helperText="Please select your option"
                    InputLabelProps={{ shrink: true }}
                    style={{ width: "400px" }}
                  >
                    <MenuItem value="1">1</MenuItem>
                    <MenuItem value="2">2</MenuItem>
                    <MenuItem value="3">3</MenuItem>
                    <MenuItem value="4">4</MenuItem>
                    <MenuItem value="5">5</MenuItem>
                  </TextField>
                  <TextField
                    required
                    select
                    id="length_of_presentation"
                    label="length_of_presentation"
                    name="length_of_presentation"
                    value={Event.Specifics.length_of_presentation}
                    onChange={handleSpecificsChange}
                    helperText="Please select your option"
                    InputLabelProps={{ shrink: true }}
                    style={{ width: "400px" }}
                  >
                    <MenuItem value="30">30</MenuItem>
                    <MenuItem value="45">45</MenuItem>
                    <MenuItem value="60">60</MenuItem>
                    <MenuItem value="90">90</MenuItem>
                    <MenuItem value="longer">longer</MenuItem>
                  </TextField>
                  <TextField
                    required
                    select
                    id="students_or_parents"
                    label="students_or_parents"
                    name="students_or_parents"
                    value={Event.Specifics.students_or_parents}
                    onChange={handleSpecificsChange}
                    helperText="Please select your option"
                    InputLabelProps={{ shrink: true }}
                    style={{ width: "400px" }}
                  >
                    <MenuItem value="Students">Students</MenuItem>
                    <MenuItem value="Parents">Parents</MenuItem>
                    <MenuItem value="Mix">Mix</MenuItem>
                  </TextField>
                  <TextField
                    required
                    id="how_many_attendees"
                    label="how_many_attendees"
                    value={Event.Specifics.how_many_attendees}
                    name="how_many_attendees"
                    onChange={handleSpecificsChange}
                    type="number"
                    InputLabelProps={{ shrink: true }}
                    style={{ width: "400px" }}
                  />

                  <TextField
                    select
                    id="year_group"
                    label="Year Group"
                    name="year_group"
                    value={Event.Specifics.year_group}
                    onChange={handleSpecificsChange}
                    helperText="Please select your options"
                    InputLabelProps={{ shrink: true }}
                    style={{ width: "400px" }}
                    SelectProps={{
                      multiple: true,
                    }}
                  >
                    <MenuItem value="7">7</MenuItem>
                    <MenuItem value="8">8</MenuItem>
                    <MenuItem value="9">9</MenuItem>
                    <MenuItem value="10">10</MenuItem>
                    <MenuItem value="11">11</MenuItem>
                    <MenuItem value="12">12</MenuItem>
                    <MenuItem value="13">13</MenuItem>
                  </TextField>
                  <TextField
                    required
                    select
                    id="sxp_sell_included"
                    label="sxp_sell_included"
                    name="sxp_sell_included"
                    value={Event.Specifics.sxp_sell_included}
                    onChange={handleSpecificsChange}
                    helperText="Please select your option"
                    InputLabelProps={{ shrink: true }}
                    style={{ width: "400px" }}
                  >
                    <MenuItem value="Yes">Yes</MenuItem>
                    <MenuItem value="No">No</MenuItem>
                  </TextField>
                  <TextField
                    required
                    id="number_of_leads_generated"
                    label="number_of_leads_generated"
                    value={Event.Specifics.number_of_leads_generated}
                    name="number_of_leads_generated"
                    onChange={handleSpecificsChange}
                    type="number"
                    InputLabelProps={{ shrink: true }}
                    style={{ width: "400px" }}
                  />

                  <TextField
                    required
                    select
                    id="student_engagement_heat"
                    label="student_engagement_heat"
                    name="student_engagement_heat"
                    value={Event.Specifics.student_engagement_heat}
                    onChange={handleSpecificsChange}
                    helperText="Please select your option"
                    InputLabelProps={{ shrink: true }}
                    style={{ width: "400px" }}
                  >
                    <MenuItem value="Hot">Hot</MenuItem>
                    <MenuItem value="Warm">Warm</MenuItem>
                    <MenuItem value="Cold">Cold</MenuItem>
                  </TextField>
                  <TextField
                    required
                    id="why_do_you_feel_they_were_this_engaged"
                    label="why_do_you_feel_they_were_this_engaged"
                    value={
                      Event.Specifics.why_do_you_feel_they_were_this_engaged
                    }
                    name="why_do_you_feel_they_were_this_engaged"
                    onChange={handleSpecificsChange}
                    InputLabelProps={{ shrink: true }}
                    style={{ width: "400px" }}
                  />
                </>
              ) : (
                <></>
              )}

              {Event.hs_activity_type === "Careers Fair" ? (
                <>
                  <TextField
                    required
                    select
                    id="length_of_fair"
                    label="length_of_fair"
                    name="length_of_fair"
                    value={Event.Specifics.length_of_fair}
                    onChange={handleSpecificsChange}
                    helperText="Please select your option"
                    InputLabelProps={{ shrink: true }}
                    style={{ width: "400px" }}
                  >
                    <MenuItem value="Couple Hours">Couple Hours</MenuItem>
                    <MenuItem value="Half Day">Half Day</MenuItem>
                    <MenuItem value="Full Day">Full Day</MenuItem>
                  </TextField>
                  <TextField
                    required
                    select
                    id="worth_attending"
                    label="worth_attending"
                    name="worth_attending"
                    value={Event.Specifics.worth_attending}
                    onChange={handleSpecificsChange}
                    helperText="Please select your option"
                    InputLabelProps={{ shrink: true }}
                    style={{ width: "400px" }}
                  >
                    <MenuItem value="Yes">Yes</MenuItem>
                    <MenuItem value="No">No</MenuItem>
                  </TextField>
                  <TextField
                    required
                    select
                    id="leads_generated"
                    label="leads_generated"
                    name="leads_generated"
                    value={Event.Specifics.leads_generated}
                    onChange={handleSpecificsChange}
                    helperText="Please select your option"
                    InputLabelProps={{ shrink: true }}
                    style={{ width: "400px" }}
                  >
                    <MenuItem value="Yes">Yes</MenuItem>
                    <MenuItem value="No">No</MenuItem>
                  </TextField>
                  <TextField
                    required
                    id="number_of_leads_generated"
                    label="number_of_leads_generated"
                    value={Event.Specifics.number_of_leads_generated}
                    name="number_of_leads_generated"
                    onChange={handleSpecificsChange}
                    type="number"
                    InputLabelProps={{ shrink: true }}
                    style={{ width: "400px" }}
                  />
                  <TextField
                    required
                    select
                    id="leads_passed_to_stx"
                    label="leads_passed_to_stx"
                    name="leads_passed_to_stx"
                    value={Event.Specifics.leads_passed_to_stx}
                    onChange={handleSpecificsChange}
                    helperText="Please select your option"
                    InputLabelProps={{ shrink: true }}
                    style={{ width: "400px" }}
                  >
                    <MenuItem value="Yes">Yes</MenuItem>
                    <MenuItem value="No">No</MenuItem>
                  </TextField>
                  <TextField
                    select
                    id="year_group"
                    label="Year Group"
                    name="year_group"
                    value={Event.Specifics.year_group}
                    onChange={handleSpecificsChange}
                    helperText="Please select your options"
                    InputLabelProps={{ shrink: true }}
                    style={{ width: "400px" }}
                    SelectProps={{
                      multiple: true,
                    }}
                  >
                    <MenuItem value="7">7</MenuItem>
                    <MenuItem value="8">8</MenuItem>
                    <MenuItem value="9">9</MenuItem>
                    <MenuItem value="10">10</MenuItem>
                    <MenuItem value="11">11</MenuItem>
                    <MenuItem value="12">12</MenuItem>
                    <MenuItem value="13">13</MenuItem>
                  </TextField>

                  <TextField
                    required
                    select
                    id="parents_present"
                    label="parents_present"
                    name="parents_present"
                    value={Event.Specifics.parents_present}
                    onChange={handleSpecificsChange}
                    helperText="Please select your option"
                    InputLabelProps={{ shrink: true }}
                    style={{ width: "400px" }}
                  >
                    <MenuItem value="Yes">Yes</MenuItem>
                    <MenuItem value="No">No</MenuItem>
                  </TextField>
                  <TextField
                    required
                    select
                    id="talk_delivered"
                    label="talk_delivered"
                    name="talk_delivered"
                    value={Event.Specifics.talk_delivered}
                    onChange={handleSpecificsChange}
                    helperText="Please select your option"
                    InputLabelProps={{ shrink: true }}
                    style={{ width: "400px" }}
                  >
                    <MenuItem value="Yes">Yes</MenuItem>
                    <MenuItem value="No">No</MenuItem>
                  </TextField>
                  {Event.Specifics &&
                  Event.Specifics.talk_delivered &&
                  Event.Specifics.talk_delivered === "Yes" ? (
                    <>
                      <TextField
                        required
                        select
                        id="topic"
                        label="Topic"
                        name="topic"
                        value={Event.Specifics.topic}
                        onChange={handleSpecificsChange}
                        helperText="Please select your option"
                        InputLabelProps={{ shrink: true }}
                        style={{ width: "400px" }}
                      >
                        <MenuItem value="SXP Sell">SXP Sell</MenuItem>
                        <MenuItem value="Essential Employability Skills">
                          Essential Employability Skills
                        </MenuItem>
                        <MenuItem value="Navigating Your Next Steps">
                          Navigating Your Next Steps
                        </MenuItem>
                        <MenuItem value="Making the Most of Work Experience">
                          Making the Most of Work Experience
                        </MenuItem>
                        <MenuItem value="Other">Other</MenuItem>
                      </TextField>
                    </>
                  ) : (
                    <>
                      <TextField
                        required
                        id="why_no_talk_delivered"
                        label="why_no_talk_delivered"
                        value={Event.Specifics.why_no_talk_delivered}
                        name="why_no_talk_delivered"
                        onChange={handleSpecificsChange}
                        InputLabelProps={{ shrink: true }}
                        style={{ width: "400px" }}
                      />
                    </>
                  )}
                  <TextField
                    required
                    select
                    id="student_engagement_heat"
                    label="student_engagement_heat"
                    name="student_engagement_heat"
                    value={Event.Specifics.student_engagement_heat}
                    onChange={handleSpecificsChange}
                    helperText="Please select your option"
                    InputLabelProps={{ shrink: true }}
                    style={{ width: "400px" }}
                  >
                    <MenuItem value="Hot">Hot</MenuItem>
                    <MenuItem value="Warm">Warm</MenuItem>
                    <MenuItem value="Cold">Cold</MenuItem>
                  </TextField>
                  <TextField
                    required
                    id="why_do_you_feel_they_were_this_engaged"
                    label="why_do_you_feel_they_were_this_engaged"
                    value={
                      Event.Specifics.why_do_you_feel_they_were_this_engaged
                    }
                    name="why_do_you_feel_they_were_this_engaged"
                    onChange={handleSpecificsChange}
                    InputLabelProps={{ shrink: true }}
                    style={{ width: "400px" }}
                  />
                </>
              ) : (
                <></>
              )}

              <section>
                <Typography variant="h6" gutterBottom>
                  Task - Next Aim:
                </Typography>
                <TextField
                  required
                  select
                  id="ExtraTask_Need"
                  label="ExtraTask_Need"
                  name="ExtraTask_Need"
                  value={
                    Event.ExtraTask && Event.ExtraTask.ExtraTask_Need
                      ? Event.ExtraTask.ExtraTask_Need
                      : ""
                  }
                  onChange={handleExtraTaskChange}
                  helperText="Please select your option"
                  InputLabelProps={{ shrink: true }}
                  style={{ width: "400px" }}
                >
                  <MenuItem value="Yes">Yes</MenuItem>
                  <MenuItem value="No">No</MenuItem>
                </TextField>

                {Event.ExtraTask && Event.ExtraTask.ExtraTask_Need === "Yes" ? (
                  <>
                    <TextField
                      required
                      id="ExtraTask_Body"
                      label="ExtraTask_Body"
                      value={
                        Event.ExtraTask && Event.ExtraTask.ExtraTask_Body
                          ? Event.ExtraTask.ExtraTask_Body
                          : ""
                      }
                      name="ExtraTask_Body"
                      onChange={handleExtraTaskChange}
                      InputLabelProps={{ shrink: true }}
                      style={{ width: "400px" }}
                    />
                    <TextField
                      required
                      id="ExtraTask_Subject"
                      label="ExtraTask_Subject"
                      value={
                        Event.ExtraTask && Event.ExtraTask.ExtraTask_Subject
                          ? Event.ExtraTask.ExtraTask_Subject
                          : ""
                      }
                      name="ExtraTask_Subject"
                      onChange={handleExtraTaskChange}
                      InputLabelProps={{ shrink: true }}
                      style={{ width: "400px" }}
                    />
                    <TextField
                      required
                      id="ExtraTask_Time"
                      label="ExtraTask_Time"
                      value={
                        Event.ExtraTask && Event.ExtraTask.ExtraTask_Time
                          ? Event.ExtraTask.ExtraTask_Time
                          : ""
                      }
                      name="ExtraTask_Time"
                      type="number"
                      onChange={handleExtraTaskChange}
                      InputLabelProps={{ shrink: true }}
                      style={{ width: "400px" }}
                    />
                  </>
                ) : (
                  <></>
                )}
              </section>

              <section>
                {Event.ExtraTask && Event.ExtraTask.ExtraTask_Need === "Yes" ? (
                  <>
                    <Typography variant="h6" gutterBottom>
                      Other Task:
                    </Typography>
                    <TextField
                      required
                      select
                      id="ExtraTask2_Need"
                      label="ExtraTask2_Need"
                      name="ExtraTask2_Need"
                      value={
                        Event.ExtraTask2 && Event.ExtraTask2.ExtraTask2_Need
                          ? Event.ExtraTask2.ExtraTask2_Need
                          : ""
                      }
                      onChange={handleExtraTask2Change}
                      helperText="Please select your option"
                      InputLabelProps={{ shrink: true }}
                      style={{ width: "400px" }}
                    >
                      <MenuItem value="Yes">Yes</MenuItem>
                      <MenuItem value="No">No</MenuItem>
                    </TextField>
                  </>
                ) : (
                  <></>
                )}

                {Event.ExtraTask2 &&
                Event.ExtraTask2.ExtraTask2_Need === "Yes" ? (
                  <>
                    <TextField
                      required
                      id="ExtraTask2_Body"
                      label="ExtraTask2_Body"
                      value={
                        Event.ExtraTask2 && Event.ExtraTask2.ExtraTask2_Body
                          ? Event.ExtraTask2.ExtraTask2_Body
                          : ""
                      }
                      name="ExtraTask2_Body"
                      onChange={handleExtraTask2Change}
                      InputLabelProps={{ shrink: true }}
                      style={{ width: "400px" }}
                    />
                    <TextField
                      required
                      id="ExtraTask2_Subject"
                      label="ExtraTask2_Subject"
                      value={
                        Event.ExtraTask2 && Event.ExtraTask2.ExtraTask2_Subject
                          ? Event.ExtraTask2.ExtraTask2_Subject
                          : ""
                      }
                      name="ExtraTask2_Subject"
                      onChange={handleExtraTask2Change}
                      InputLabelProps={{ shrink: true }}
                      style={{ width: "400px" }}
                    />
                    <TextField
                      required
                      id="ExtraTask2_Time"
                      label="ExtraTask2_Time"
                      value={
                        Event.ExtraTask2 && Event.ExtraTask2.ExtraTask2_Time
                          ? Event.ExtraTask2.ExtraTask2_Time
                          : ""
                      }
                      name="ExtraTask2_Time"
                      type="number"
                      onChange={handleExtraTask2Change}
                      InputLabelProps={{ shrink: true }}
                      style={{ width: "400px" }}
                    />
                  </>
                ) : (
                  <></>
                )}
              </section>

              <section>
                {Event.ExtraTask2 &&
                Event.ExtraTask2.ExtraTask2_Need === "Yes" ? (
                  <>
                    <Typography variant="h6" gutterBottom>
                      Other Other Task:
                    </Typography>
                    <TextField
                      required
                      select
                      id="ExtraTask3_Need"
                      label="ExtraTask3_Need"
                      name="ExtraTask3_Need"
                      value={
                        Event.ExtraTask3 && Event.ExtraTask3.ExtraTask3_Need
                          ? Event.ExtraTask3.ExtraTask3_Need
                          : ""
                      }
                      onChange={handleExtraTask3Change}
                      helperText="Please select your option"
                      InputLabelProps={{ shrink: true }}
                      style={{ width: "400px" }}
                    >
                      <MenuItem value="Yes">Yes</MenuItem>
                      <MenuItem value="No">No</MenuItem>
                    </TextField>
                  </>
                ) : (
                  <></>
                )}

                {Event.ExtraTask3 &&
                Event.ExtraTask3.ExtraTask3_Need === "Yes" ? (
                  <>
                    <TextField
                      required
                      id="ExtraTask3_Body"
                      label="ExtraTask3_Body"
                      value={
                        Event.ExtraTask3 && Event.ExtraTask3.ExtraTask3_Body
                          ? Event.ExtraTask3.ExtraTask3_Body
                          : ""
                      }
                      name="ExtraTask3_Body"
                      onChange={handleExtraTask3Change}
                      InputLabelProps={{ shrink: true }}
                      style={{ width: "400px" }}
                    />
                    <TextField
                      required
                      id="ExtraTask3_Subject"
                      label="ExtraTask3_Subject"
                      value={
                        Event.ExtraTask3 && Event.ExtraTask3.ExtraTask3_Subject
                          ? Event.ExtraTask3.ExtraTask3_Subject
                          : ""
                      }
                      name="ExtraTask3_Subject"
                      onChange={handleExtraTask3Change}
                      InputLabelProps={{ shrink: true }}
                      style={{ width: "400px" }}
                    />
                    <TextField
                      required
                      id="ExtraTask3_Time"
                      label="ExtraTask3_Time"
                      value={
                        Event.ExtraTask3 && Event.ExtraTask3.ExtraTask3_Time
                          ? Event.ExtraTask3.ExtraTask3_Time
                          : ""
                      }
                      name="ExtraTask3_Time"
                      type="number"
                      onChange={handleExtraTask3Change}
                      InputLabelProps={{ shrink: true }}
                      style={{ width: "400px" }}
                    />
                  </>
                ) : (
                  <></>
                )}
              </section>

              <Button
                type="submit"
                variant="contained"
                sx={{ mt: 3, ml: 1 }}
                disabled={!isFormValid || isSubmitting}
              >
                {isSubmitting ? "Submitting..." : "Log Event"}
              </Button>
            </Box>
          </Typography>
        ) : (
          <>
            No Hubspot ID Detected. Please open "View School" and assign to
            Hubspot
            <Link
              to={`/Staff/ViewSchool/${id}`}
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <button>View</button>
            </Link>
          </>
        )}
      </Container>
    </div>
  );
};

export default LogSchoolEvent;
